import { BaseComponent } from '../../lib/base-component.js';
import { css, html } from '../../lib/lit.js';

/**
 * <community-footer> — the app-wide site footer: copyright, legal links, and the
 * deployed API version (omitted when unknown). The `version` is threaded down
 * from the SPA's `/config` fetch. Mirrors <vtt-footer>.
 *
 * The Terms/Privacy links point at this app's own `/terms` and `/privacy`
 * routes, which render the documents d3-auth publishes (it owns the consent
 * corpus as data; the portal only displays it). Both routes are public —
 * reachable from here while signed out.
 */
export class CommunityFooter extends BaseComponent {
    static properties = {
        version: { type: String },
    };

    static styles = css`
        :host {
            display: block;
        }
    `;

    constructor() {
        super();
        /** @type {string} */
        this.version = '';
    }

    render() {
        return html`
            <footer class="text-muted small py-3 px-3 text-center">
                <div class="d-flex justify-content-center align-items-center flex-wrap gap-2">
                    <span>© 2026 Dice Driven Design LLC</span>
                    ${
                        this.version
                            ? html`<span class="text-secondary">·</span><span>${this.version}</span>`
                            : ''
                    }
                </div>
                <div class="mt-1">
                    <a class="link-secondary text-decoration-none" href="/terms">Terms</a>
                    <span class="text-secondary mx-1">·</span>
                    <a class="link-secondary text-decoration-none" href="/privacy">Privacy</a>
                </div>
            </footer>
        `;
    }
}

customElements.define('community-footer', CommunityFooter);
